import type { ImageAttachment } from '@voice-assistant/shared';

interface Props {
  attachments: ImageAttachment[];
  processing: boolean;
  error: string | null;
  onRemove: (index: number) => void;
  busy: boolean;
}

export function AttachmentPreview({
  attachments,
  processing,
  error,
  onRemove,
}: Props) {
  if (attachments.length === 0 && !processing && !error) return null;

  return (
    <div class="attachment-preview">
      {error && <div class="attachment-error">{error}</div>}
      <div class="attachment-strip">
        {attachments.map((att, i) => (
          <div key={i} class="attachment-thumb-wrap">
            <img
              class="attachment-thumb"
              src={att.thumbnailDataUri}
              alt={att.fileName}
              role="button"
              tabIndex={0}
              onClick={() => window.dispatchEvent(new CustomEvent('open-image-overlay', { detail: `data:${att.mimeType};base64,${att.data}` }))}
            />
            <button
              class="attachment-remove"
              onClick={() => onRemove(i)}
              title="Remove"
            >
              x
            </button>
          </div>
        ))}
        {processing && (
          <div class="attachment-thumb-wrap processing">
            <div class="spinner" style={{ width: 24, height: 24, borderWidth: 2 }} />
          </div>
        )}
      </div>
      {attachments.length > 0 && (
        <span class="attachment-hint">
          {attachments.length} image{attachments.length > 1 ? 's' : ''} attached — type a message and tap ➤, or hold mic
        </span>
      )}
    </div>
  );
}
